<div class="ems-multiselect" [ngClass]="{'add-multiselect': changeHeight, 'rounded-multiselect': rounded, 'no-label-multiselect': !label, 'dropdown-open': dropdownVisible}">

  <button type="button" class="anchor" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()"
       [disabled]="disabled"
       [attr.aria-label]="label"
       [attr.aria-expanded]="dropdownVisible" aria-haspopup="listbox">

    <label *ngIf="label" [ngClass]="{'active': value !== null && value.length > 0,'labelDisabled': disabled}">{{label}}<em *ngIf="highlightColor && !disabled" class="highlight-color">*</em></label>

    <span [ngClass]="{'labelDisabled': disabled}" class="dropdown-icon sdps-pull-right pi pi-caret-down security-arrow-icon" aria-hidden="true"></span>

    <div class="items-selected">

      <div class="item-selected" *ngIf="shouldShowAllSelected">
        All
      </div>

      <div *ngIf="value !== null && value.length < selectedCountThreshold && !shouldShowAllSelected">

        <span class="item-selected" *ngFor="let data of value">
          {{ data.label }}
        </span>

      </div>

      <div class="item-selected" *ngIf="value !== null && value.length >= selectedCountThreshold && !shouldShowAllSelected">
        {{value.length}} Selected
      </div>

    </div>

  </button>

  <div class="items" *ngIf="dropdownVisible" role="listbox" [ngClass]="{'active': dropdownVisible}">

    <div #parentItems style="width:max-content; min-width: 100%;">

      <label *ngIf="searchable">
        <input type="text" aria-label="Filter options" class="filter" placeholder="Filter" [(ngModel)]="filterValue" (keyup)="filterOptions()" />
      </label>

      <label *ngIf="!singleSelect && optionsToShow.length > 0">

        <div [ngClass]="{'active': selectAll, 'item-label': true}">
          All
          <p-checkbox #checkboxElement class="emtr-checkbox" [value]='selectAll' (onChange)="selectAllItems()" [(ngModel)]='selectAll'
            binary=true>
          </p-checkbox>
        </div>

      </label>

      <label *ngFor="let option of optionsToShow; let i = index">

        <div [ngClass]="{'active': isSelected(option), 'item-label': true}">
          {{ option.label }}
          <p-checkbox class="emtr-checkbox" [ngStyle]="singleSelect && {'display': 'none'}" [value]="option"
            (onChange)="onChange(option)" [(ngModel)]='value'></p-checkbox>
        </div>

      </label>

    </div>

  </div>

</div>
